/*! @azure/msal-common v14.16.1 2025-08-05 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.16.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
